import { useEffect } from 'react';

function animateCounter(el) {
  const target = parseInt(el.getAttribute('data-count') || '0', 10);
  const duration = 1400;
  const start = performance.now();

  function frame(now) {
    const p = Math.min(1, (now - start) / duration);
    const eased = 1 - Math.pow(1 - p, 3);
    el.textContent = Math.round(target * eased).toLocaleString('en-US');
    if (p < 1) requestAnimationFrame(frame);
  }

  requestAnimationFrame(frame);
}

export function useStatCounters(rootRef) {
  useEffect(() => {
    const root = rootRef?.current || document;
    const nodes = root.querySelectorAll('[data-count]');
    if (!nodes.length) return undefined;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          animateCounter(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    nodes.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [rootRef]);
}
